import { ReactElement, useState } from 'react';
import { Button } from '../../../core/components';
import { tokens } from '../../../core/theme';
import { FaqMenu, FaqModal } from '../components';
import { FaqContent } from '../utils/faqContent';
import { useIsDesktop, usePageTitle } from '../../../core/hooks';

export const FaqPage = (): ReactElement => {
  const [selectedContent, setSelectedContent] = useState<FaqContent | null>(null);
  const isDesktop = useIsDesktop();
  usePageTitle('Informação');

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Informação</h1>
      <FaqMenu onSelectTopic={setSelectedContent} clearSelection={selectedContent === null} />
      <Button variant="primary" expanded={!isDesktop} to={'/'}>
        Voltar
      </Button>
      {selectedContent && (
        <FaqModal
          icon={selectedContent.card.icon}
          title={selectedContent.card.title}
          sections={selectedContent.sections}
          onClose={() => setSelectedContent(null)}
        />
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacing.default,
    width: '100%',
    padding: `${tokens.spacing.default} ${tokens.spacing.pageGutter}`,
    paddingBottom: tokens.spacing.large,
    boxSizing: 'border-box',
  },
  heading: {
    margin: 0,
    fontSize: tokens.typography.fontSize.heading,
    fontWeight: tokens.typography.fontWeight.semiBold,
    lineHeight: tokens.typography.lineHeight.heading,
    color: tokens.colors.global.black,
  },
};
